<h2>Toast Notifications</h2>

<!-- Toast containers for both styles -->
<app-toast type="1" key="style1"></app-toast>
<app-toast type="1" key="style1-sticky"></app-toast>
<app-toast type="2" key="style2"></app-toast>
<app-toast type="2" key="style2-sticky"></app-toast>

<h3>Type 1</h3>
<div class="examples-container">
	<div class="example-card">
		<span class="label">Éxito</span>
		<button type="button" pButton class="p-button-success" label="Mostrar Éxito" (click)="showSuccess('style1')"></button>
		<app-ui-code-block [code]="successCode" />
	</div>

	<div class="example-card">
		<span class="label">Información</span>
		<button type="button" pButton class="p-button-info" label="Mostrar Info" (click)="showInfo('style1')"></button>
		<app-ui-code-block [code]="infoCode" />
	</div>

	<div class="example-card">
		<span class="label">Advertencia</span>
		<button type="button" pButton class="p-button-warning" label="Mostrar Advertencia" (click)="showWarn('style1')"></button>
		<app-ui-code-block [code]="warnCode" />
	</div>

	<div class="example-card">
		<span class="label">Error</span>
		<button type="button" pButton class="p-button-danger" label="Mostrar Error" (click)="showError('style1')"></button>
		<app-ui-code-block [code]="errorCode" />
	</div>
</div>

<h3>Type 2</h3>
<div class="examples-container">
	<div class="example-card">
		<span class="label">Éxito</span>
		<button type="button" pButton class="p-button-success" label="Mostrar Éxito" (click)="showSuccess('style2')"></button>
		<app-ui-code-block [code]="successCode" />
	</div>

	<div class="example-card">
		<span class="label">Información</span>
		<button type="button" pButton class="p-button-info" label="Mostrar Info" (click)="showInfo('style2')"></button>
		<app-ui-code-block [code]="infoCode" />
	</div>

	<div class="example-card">
		<span class="label">Advertencia</span>
		<button type="button" pButton class="p-button-warning" label="Mostrar Advertencia" (click)="showWarn('style2')"></button>
		<app-ui-code-block [code]="warnCode" />
	</div>

	<div class="example-card">
		<span class="label">Error</span>
		<button type="button" pButton class="p-button-danger" label="Mostrar Error" (click)="showError('style2')"></button>
		<app-ui-code-block [code]="errorCode" />
	</div>
</div>

<h3>Sticky (No se cierra automáticamente)</h3>
<div class="examples-container">
	<div class="example-card">
		<span class="label">Type 1 - Advertencia Persistente</span>
		<button type="button" pButton class="p-button-warning" label="Mostrar Toast Sticky Type 1" (click)="showStickyInfoStyle1()"></button>
		<app-ui-code-block [code]="stickyCode" />
	</div>

	<div class="example-card">
		<span class="label">Type 2 - Información Persistente</span>
		<button type="button" pButton class="p-button-info" label="Mostrar Toast Sticky Type 2" (click)="showStickyInfo()"></button>
		<app-ui-code-block [code]="stickyCode" />
	</div>
</div>
